import React, { Component } from "react";
import { Sidebarc } from "../Sidebar";
import { Appheaderc } from "../Appheader";
import { Button, Grid2, Paper, Typography } from "@mui/material";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import AddIcon from '@mui/icons-material/FormatListNumbered';
import { useNavigate, useLocation, useParams } from 'react-router-dom'; 
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import {
  MenuItem,
  TextField,
  InputAdornment,
} from "@mui/material";
import base_url from "../baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const drawerWidth = 240;

class EditProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product_name: "",
      product_description: "",
      weight: "",
      metal_type: "",
      product_type: "",
      thumb_nail_img: "",
      price : 0,
      product_id  :"",

      productImage: [],


      productImageList : [],
      categoryList:[],
      is_uploading : false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };


  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };


  handleChangeeOne = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };


  componentDidMount() {
  //// retrive single product details
 
  fetch(`${base_url.base_url}/product/retriveSingleProduct`, {
    headers: {
      "content-type": "application/json",
    },
    method: "post",
    body:JSON.stringify({
      product_id :  this.props.param.id.replace(/:/g,'')
    })
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
    this.setState({
      product_name: result.data.product_name,
      product_description: result.data.product_description,
      weight: result.data.weight,
      metal_type: result.data.metal_type,
      product_type: result.data.product_type,
      thumb_nail_img: result.data.thumb_nail_img,
      price : result.data.price,
      product_id  : result.data.product_id,
      productImageList : result.data.productImage
    })
    });


    fetch(`${base_url.base_url}/category/retriveCategoryListForselect`, {
          headers: {
            "content-type": "application/json",
          },
          method: "get",
        })
          .then((res) => {
            return res.json();
          })
          .then((result) => {
            this.setState({
              categoryList: result.data,
            });
          });
  }



instantRetrive=()=>{
  fetch(`${base_url.base_url}/product/retriveSingleProduct`, {
    headers: {
      "content-type": "application/json",
    },
    method: "post",
    body:JSON.stringify({
      product_id :  this.props.param.id.replace(/:/g,'')
    })
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
    this.setState({
      product_name: result.data.product_name,
      product_description: result.data.product_description,
      weight: result.data.weight,
      metal_type: result.data.metal_type,
      product_type: result.data.product_type,
      thumb_nail_img: result.data.thumb_nail_img,
      price : result.data.price,
      product_id  : result.data.product_id,
      productImageList : result.data.productImage
    })
    });
}



  handleChangePage = (event, newPage) => {};

  handleChangeRowsPerPage = (event) => {};

  autoUpdateFunction = () => {};

  

 



  



  updated = (m) => {
    toast.info(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
      {m}
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };

  render() {
    return (
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebarc />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ p: { xs: 1, sm: 3 }, mt: 6 }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
                Products Details
              </Typography>

              <Paper
                elevation={0}
                sx={{
                  height: 50,
                  width: "100%",
                  backgroundColor: "#fff",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 17,
                      fontWeight: "500",
                      paddingLeft: { xs: 1, sm: 2, md: 3 },
                      color: "#666666",
                    }}
                  >
                Edit Products
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    mr: { xs: 1, sm: 2, md: 3 },
                  }}
                >
                  <Button
                    onClick={() => this.props.navigate('/productsList')}
                    sx={{
                      textTransform: "none",
                      height: 30,
                      backgroundColor: "#008ffb",
                      fontWeight: "600",
                    }}
                    disableElevation
                    variant="contained"
                    startIcon={<AddIcon sx={{ color: "#fff" }} />}
                  >
                    Product List
                  </Button>
                </Box>
              </Paper>

              <Paper
                elevation={0}
                sx={{ width: "100%", minHeight: 300, mt: 2 }}
              >
                <Box sx={{ p: 2 }}>
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Product Name{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="product_name"
                        value={this.state.product_name}
                        onChange={this.handleChange}
                        inputProps={{ sx: { fontSize: 13, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Price{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="price"
                        value={this.state.price}
                        onChange={this.handleChange}
                        inputProps={{ sx: { fontSize: 13, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        fontWeight: "500",
                                        display: "flex",
                                      }}
                                    >
                                      Unit (examples : 1pcs, 5 gram, 2 kg etc)
                                      <Typography sx={{ color: "red" }}>*</Typography>
                                    </Typography>
                                    <TextField
                                      type="text"
                                      size="small"
                                      name="weight"
                                      value={this.state.weight}
                                      onChange={this.handleChange}
                                      inputProps={{ sx: { fontSize: 13, fontWeight: "600" } }}
                                      fullWidth
                                    />
                                  </Grid2>

                       <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                      <Typography
                                        sx={{
                                          fontSize: 13,
                                          fontWeight: "500",
                                          display: "flex",
                                        }}
                                      >
                                        Products category{" "}
                                        <Typography sx={{ color: "red" }}>*</Typography>
                                      </Typography>
                                      <TextField
                                        size="small"
                                        name="product_type"
                                        value={this.state.product_type}
                                        onChange={this.handleChange}
                                        inputProps={{ sx: { fontSize: 12, fontWeight: "600" } }}
                                        select
                                        defaultValue={this.state.product_type}
                                        fullWidth
                                      >
                                        {this.state.categoryList.map((option) => (
                                          <MenuItem
                                            onClick={() =>
                                              this.setState({ product_type: option.category_name })
                                            }
                                            key={option.category_name}
                                            sx={{ fontSize: 11, fontWeight: "600" }}
                                            value={option.category_name}
                                          >
                                            {option.category_name}
                                          </MenuItem>
                                        ))}
                                      </TextField>
                                    </Grid2>

               

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Product description{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <TextField
                        size="small"
                        name="product_description"
                        value={this.state.product_description}
                        onChange={this.handleChange}
                        multiline
                        rows={3}
                        placeholder="Description"
                        defaultValue=""
                        inputProps={{ sx: { fontSize: 12, fontWeight: "600" } }}
                        fullWidth
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Thumbnail image{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <input
                        name="thumb_nail_img"
                        onChange={this.handleChangeeOne}
                        accept=".jpg,.jpeg,.png,.webp"
                        type="file"
                      />

                      <img src={`${base_url.base_url}` +'/'+ `${this.state.thumb_nail_img}`}  style={{height:50,width:70,margin:2}}/>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        Product images{" "}
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Typography>
                      <input
                        multiple
                        name="productImage"
                        onChange={this.handleChangee}
                        accept=".jpg,.jpeg,.png,.webp"
                        type="file"
                      />
                        
                        <br/>
                        <br/>
                        {
                          this.state.productImageList.map((i)=>(
                            <Box sx={{minHeight:20,width:'100%',backgroundColor:'#e9edee',mb:0.5,display:'flex',justifyContent:'center',alignItems:'center'}}>
                              <Typography sx={{fontSize:11}}>{i.img_url}</Typography>
                            </Box>
                          ))
                        }


                    </Grid2>
                  </Grid2>
                  <br />
                  <Button
                    size="small"
                    disabled={this.state.is_uploading}
                    
                    variant="contained"
                    onClick={() => {
                      let formData = new FormData();
                      formData.append("product_name", this.state.product_name);
                      formData.append(
                        "product_description",
                        this.state.product_description
                      );
                      formData.append("weight", this.state.weight);
                      formData.append("metal_type", this.state.metal_type);
                      formData.append("product_type", this.state.product_type);
                      formData.append('productImageList', JSON.stringify(this.state.productImageList) )
                      formData.append('price',this.state.price)
                      formData.append('product_id',this.state.product_id)
                      formData.append(
                        "thumb_nail_img",
                        this.state.thumb_nail_img
                      );
                      for (
                        let index = 0;
                        index < this.state.productImage.length;
                        index++
                      ) {
                        formData.append(
                          "productImage",
                          this.state.productImage[index]
                        );
                      }

                      if (
                  
                        this.state.product_name !== "" &&
                        this.state.product_type !== "" &&
                        this.state.product_description !== "" &&
                        this.state.weight !== "" &&
                        this.state.thumb_nail_img !== "" && 
                        this.state.price!==0
                      ) { this.setState({is_uploading : true});
                        fetch(`${base_url.base_url}/product/editProductDetails`, {
                          /*
  headers: {
    "content-type": "application/json",
  },
  */
                          method: "put",
                          body: formData,
                        })
                          .then((res) => {
                            return res.json();
                          })
                          .then((result) => {
                            this.setState({is_uploading:false})
                           this.instantRetrive();
                           this.updated('Products details updated')
                          });
                      } else {
                        this.updated('Fill all fields')
                      }
                    }}
                  >
                Update Submit
                  </Button>
                  <br />
                </Box>
              </Paper>

               


            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              position: "fixed",
              top: 0,
              left: { xs: 0, sm: 240 },
            }}
          >
            <Appheaderc />
          </Box>
        </Box>

        {
          //////// add userDtata data
        }

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    );
  }
}

export default EditProducts;

export function EditProductsc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<EditProducts param={param} navigate={navigate}></EditProducts>)
}


